import React, { useRef, useEffect } from 'react';
import * as d3 from 'd3';
import { AB1FileResult } from '@/api/sequencingService';
import { SANGER_COLORS } from './sangerColors';

interface SangerTraceThumbnailProps {
  result: AB1FileResult;
  onClick: () => void;
}

const SangerTraceThumbnail: React.FC<SangerTraceThumbnailProps> = ({ result, onClick }) => {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (!svgRef.current) return;

    const { channels } = result.data;
    const dataLength = channels.A.length;

    const width = 200;
    const height = 40;

    const svg = d3.select(svgRef.current)
      .attr("width", width)
      .attr("height", height);

    svg.selectAll("*").remove();

    const maxTraceValue = Math.max(
      d3.max(channels.A) || 0,
      d3.max(channels.C) || 0,
      d3.max(channels.G) || 0,
      d3.max(channels.T) || 0
    );

    if (maxTraceValue === 0) return;

    const xScale = d3.scaleLinear()
      .domain([0, dataLength])
      .range([0, width]);

    const yScale = d3.scaleLinear()
      .domain([0, maxTraceValue])
      .range([height, 0]);

    const line = d3.line<number>()
      .x((d, i) => xScale(i))
      .y(d => yScale(d));

    const channelColors = SANGER_COLORS;

    Object.entries(channels).forEach(([base, values]) => {
      svg.append("path")
        .datum(values)
        .attr("fill", "none")
        .attr("stroke", channelColors[base as keyof typeof channelColors])
        .attr("stroke-width", 0.8)
        .attr("opacity", 0.7)
        .attr("d", line);
    });

  }, [result]);

  return (
    <div onClick={onClick} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '2px 0' }}>
      <svg ref={svgRef}></svg>
    </div>
  );
};

export default SangerTraceThumbnail; 